import { useState } from "react";
import { ShoppingBag, Loader2, ShieldCheck, Coins } from "lucide-react";
import { useClicker, CoinBar, fmtCoins } from "./ClickerLayout";
import { startCheckout, usePaymentReturn } from "@/lib/checkout";

export default function ClickerStore() {
  const { config, reload } = useClicker();
  const [busy, setBusy] = useState("");
  const status = usePaymentReturn(reload);
  if (!config) return null;
  return (
    <div className="space-y-5" data-testid="clicker-store">
      <CoinBar />
      {status === "checking" && <div className="flex items-center gap-2 text-sm text-[#00F0FF]" data-testid="clicker-payment-checking"><Loader2 className="w-4 h-4 animate-spin" /> Confirming your payment…</div>}
      <h2 className="font-black text-base flex items-center gap-2"><ShoppingBag className="w-4 h-4 text-[#FFE300]" /> Coin store</h2>
      <div className="grid gap-3">
        {config.packages.map((p, i) => (
          <div key={p.id} className="rounded-2xl p-4 flex items-center gap-4 border border-[#FFE300]/25 bg-gradient-to-r from-[#FFE300]/10 to-transparent" data-testid={`clicker-pack-${p.id}`}>
            <Coins className={`text-[#FFE300] ${["w-8 h-8", "w-10 h-10", "w-12 h-12"][i] || "w-8 h-8"}`} />
            <div className="flex-1">
              <div className="font-black text-xl">{fmtCoins(p.coins)} coins</div>
              <div className="text-[11px] text-white/50">{p.name}</div>
            </div>
            <button disabled={!!busy} onClick={async () => { setBusy(p.id); await startCheckout(p.id); setBusy(""); }}
              data-testid={`clicker-pack-buy-${p.id}`}
              className="min-w-[84px] bg-[#FFE300] hover:bg-white text-black font-black text-sm px-4 py-2.5 rounded-full transition-colors disabled:opacity-60">
              {busy === p.id ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : `$${p.price.toFixed(2)}`}
            </button>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-white/40 flex items-start gap-2"><ShieldCheck className="w-4 h-4 shrink-0 text-[#39FF14]" /> Secure checkout by Stripe. Coins are credited only after the payment is verified on our server. Coins have no cash value.</p>
    </div>
  );
}
